export default "__VITE_ASSET__D9eD5CjE__"